import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AdminDialogService} from "../../services/admin-dialogs-service.service";
import {PoliciesAlertsService} from "../../../policies/services/policies-alerts.service";
import {PoliciesDialogService} from "../../../policies/services/policies-dialogs-service.service";
import {PoliciesRequestsService} from "../../../policies/services/policies-requests.service";
import {PoliciesService} from "../../../policies/services/policies-service.service";
import {PreferencesDialogService} from "../../../site-preferences/services/preferences-dialogs-service.service";
import {EmailReportTemplateEnum} from "../../../site-preferences/types/email-report-template.enum";
import {BranchModel} from "../../../branches/models/branch.model";
import {BranchReferenceModel} from "../../../branches/models/branch-reference.model";
import {TeamModel} from "../../../teams/models/team.model";

export class adminUserInfoCtrl implements IController {
  user: any;
  userBranches: BranchModel[] | BranchReferenceModel[];
  userTeams: TeamModel[];
  extendedPolicy: any;
  emailNotificationConfigurations: any;
  orgId?: any;
  siteId?: any;

  public userRoles: any;
  public userGroups: any;

  public rolesGroups: any = [];
  public rolesGroupsMap: {} = {};
  private loading: boolean;
  private isMobile: boolean;
  public excludedEmailReportTypes: EmailReportTemplateEnum[];
  public userBranchIds: string[];
  public hasSiteAccess: boolean;

  /* @ngInject */
  constructor(private $log, private adminDialogService: AdminDialogService, private policiesRequestsService: PoliciesRequestsService,
              private policiesDialogService: PoliciesDialogService, private policiesAlertsService: PoliciesAlertsService,
              private IamRequests, private $mdMedia, private policiesService: PoliciesService, private preferencesDialogService: PreferencesDialogService) {
  }

  $onInit() {

    if (!!this.userBranches?.length) {
      this.userBranchIds = this.userBranches.map(b => b.id);
    }

    if (!this.emailNotificationConfigurations) {
      this.emailNotificationConfigurations = [];
    }

    this.emailNotificationConfigurations = this.emailNotificationConfigurations.filter(notification => !notification.visibleToAdmin);

    this.excludedEmailReportTypes = this.emailNotificationConfigurations.map(item => item.emailReportType);

    if (!this.user.inactiveSites) {
      this.user.inactiveSites = [];
    }
    if (this.siteId) {
      this.hasSiteAccess = !this.user.inactiveSites.includes(this.siteId);
    }

    // this.emailNotificationConfigurationsCopy = angular.copy(this.emailNotificationConfigurations);


    this.isMobile = !this.$mdMedia('gt-md');
    if (this.extendedPolicy) {
      this._setRolesAndGroups(this.extendedPolicy.policy);

      this.policiesService.getAllRolesGroups(this.extendedPolicy.policy.id, this.orgId, this.siteId)
        .then((groups: any) => {
          this.rolesGroups = groups;

          this.rolesGroupsMap = {};
          _.forEach(groups, (g) => {
            this.rolesGroupsMap[g.id] = g;
          })
        });
    }
  }

  onPictureChange(editedUser) {
    this.loading = true;
    this.IamRequests.editUser(this.user.id, editedUser, this.orgId, this.siteId, this.extendedPolicy.policy.id)
      .then((updatedUser) => {
        this.user = updatedUser;
        this.policiesAlertsService.updateImageSuccess();
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateImageError();
          this.$log.error('Failed to update user Picture @adminUserView@onPictureChange', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onEditPassword(event) {
    this.adminDialogService.editPassword(event, this.user, this.extendedPolicy.policy.passwordPolicy)
      .then((editedUser) => {
        this.loading = true;
        return this.IamRequests.editUser(this.user.id, editedUser, this.orgId, this.siteId, this.extendedPolicy.policy.id);
      })
      .then((updatedUser) => {
        this.user = updatedUser;
        this.policiesAlertsService.updatePasswordSuccess();
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updatePasswordError();
          this.$log.error('Failed to update user password @adminUserView@onEditPassword', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onEditUser(event) {
    this.adminDialogService.editUser(event, this.user)
      .then((payload) => {
        this.loading = true;
        return this.IamRequests.editUser(this.user.id, payload.user, this.orgId, this.siteId, this.extendedPolicy.policy.id, payload.expirationDays, payload.removeExpiration);
      })
      .then((updatedUser) => {
        this.user = updatedUser;
        this.policiesAlertsService.updateInfoSuccess();
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateInfoError();
          this.$log.error('Failed to update admin user profile @adminUserView@onEditUser', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onEditRoles(event) {
    this.policiesDialogService.editUserRoles(event, this.user, this.userRoles, this.extendedPolicy.roles, this.userGroups, this.rolesGroups)
      .then((bindings: { roleId?: string[], rolesGroupId?: string[] }[]) => {
        this.loading = true;
        return this.policiesRequestsService.editUserBindings(
          this.extendedPolicy.policy.id,
          this.user.id,
          bindings,
          this.orgId,
          this.siteId
        );
      })
      .then((updatedPolicies) => {
        this.policiesAlertsService.updateRolesSuccess();
        this._setRolesAndGroups(updatedPolicies);
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateRolesError();
          this.$log.error('Failed to update policy @adminUserView@onEditRoles', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onAddUserReports(event) {
    this.preferencesDialogService.createEmailReportConfiguration(this.excludedEmailReportTypes, 'Add report', false, true, this.userBranchIds, this.userTeams)
      .then((emailNotificationConfigurationsCopy) => {
        const payload = {
          emailNotificationConfigurations: [...this.emailNotificationConfigurations, emailNotificationConfigurationsCopy]
        }
        this.editUserReports(payload);
      })
  }

  onEditUserReport(emailNotificationConfiguration, index) {
    this.preferencesDialogService.editEmailReportConfiguration(emailNotificationConfiguration, this.excludedEmailReportTypes, 'Edit report', false, true, this.userBranchIds, this.userTeams)
      .then((updatedEmailNotificationConfigurationsCopy) => {
        const emailNotificationConfigurationsCopy = angular.copy(this.emailNotificationConfigurations);
        emailNotificationConfigurationsCopy.splice(index, 1, updatedEmailNotificationConfigurationsCopy);

        const payload = {
          emailNotificationConfigurations: emailNotificationConfigurationsCopy
        }
        this.editUserReports(payload);
      })
  }

  private editUserReports(payload) {
    this.policiesRequestsService.editUserReports(
      this.extendedPolicy.policy.id,
      this.user.id,
      payload,
      this.orgId,
      this.siteId
    ).then((res) => {
      this.policiesAlertsService.editUserReportsSuccess();
      this.emailNotificationConfigurations = (res.emailReportNotificationConfigurations || []).filter(c => !c.visibleToAdmin);
      this.excludedEmailReportTypes = this.emailNotificationConfigurations.map(item => item.emailReportType);
    })
      .catch(() => {
        this.policiesAlertsService.editUserReportsError();
      });
  }

  onSiteAccessChange(siteAccess: boolean) {
    this.hasSiteAccess = siteAccess;
    this.loading = true;

    let updatedInactiveSites = [...this.user.inactiveSites];

    if (siteAccess) {
      updatedInactiveSites = updatedInactiveSites.filter(siteId => siteId !== this.siteId);
    } else {
      if (!updatedInactiveSites.includes(this.siteId)) {
        updatedInactiveSites.push(this.siteId);
      }
    }

    const updatedUser = {
      ...this.user,
      inactiveSites: updatedInactiveSites
    };

    this.IamRequests.editUser(this.user.id, updatedUser, this.orgId, this.siteId, this.extendedPolicy.policy.id, null, false)
      .then((user) => {
        this.user = user;
        this.policiesAlertsService.updateInfoSuccess();
      })
      .catch((error) => {
        this.hasSiteAccess = !siteAccess;
        this.policiesAlertsService.updateInfoError();
        this.$log.error('Failed to update site access @adminUserInfo@onSiteAccessChange', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private _setRolesAndGroups(policy) {
    this.userRoles = _
      .chain(policy.bindings)
      .filter((binding) => {
        return (binding.memberId === this.user.id) && !!binding.roleId;
      })
      .map((filteredBinding) => {
        return filteredBinding.roleId
      })
      .value();

    this.userGroups = _
      .chain(policy.bindings)
      .filter((binding) => {
        return binding.memberId === this.user.id && !!binding.rolesGroupId;
      })
      .map((filteredBinding) => {
        return filteredBinding.rolesGroupId
      })
      .value();

  }


}

angular
  .module('bringoz.admin.admins')
  .component('adminUserInfo', {
    bindings: {
      user: '<',
      userBranches: '<?',
      userTeams: '<?',
      extendedPolicy: '<',
      emailNotificationConfigurations: '<?',
      orgId: '<?',
      siteId: "<?"
    },
    template: require('./admin-user-info.html').default,
    controller: adminUserInfoCtrl
  });
